/* eslint-disable */
<template>
  <div id="learner-home">
    <LearnerTableContainer v-if="activeView === 'Learner'"></LearnerTableContainer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LearnerTableContainer from  '../learner/LearnerTableContainer';

export default {
  name: 'learner-home',
  components: {
    LearnerTableContainer,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'activeView',
      'routerView',
  ]),
  ...mapGetters('learners', [
    'activeViewLearners',
    'queryParamsLearners',
    'classes'
  ]),
  },
  methods:{
  ...mapActions([
  ])
  },
  watch: {
    activeViewLearners: {
     handler: function(val, oldVal) {
        //watches for changes in student active view and calls data
        if(val === "Classes" || val === "Bulbs" || val === "Students"  || val === "Gradebook" || val === 'Playlists' || val === "Student-Interaction") {
          this.$store.dispatch('learners/getTableData');
        }
        if(val === "LMB-Monitor"){
          this.$store.dispatch('learners/getMonitorData');
        }
     }
    },
  },
  mounted() {
  }
};
</script>

<style scoped>
#learner-home {
  width: 100%;
  height: 100%;
}
</style>
